<template>
  <div class="login-signup-section">
    <div class="header-logo">
      <router-link :to="{ path: 'apps' }" class="mx-auto">
        <img src="/assets/img/logo.svg" alt="" width="232" />
      </router-link>
    </div>
    <div class="login-left-part d-md-flex align-items-center">
      <div class="form-part">
        <h1>Sign in to the Analyst Hub</h1>

        <ValidationObserver ref="form" v-slot="{ invalid }">
          <b-form
            v-on:submit.prevent="signIn(form.email, form.password)"
            class=""
          >
            <div
              id="loginErrors"
              class="errorsBlock form-group"
              v-if="loginErrors"
              v-show="loginErrors.length > 0"
            >
              <ul v-for="error in loginErrors" :key="error">
                <li>
                  {{ error.message }}
                </li>
              </ul>
            </div>

            <div id="loginGroup" horizontal class="form-group">
              <div class="form-field">
                <ValidationProvider
                  placeholder="Email"
                  name="Email"
                  rules="required|min:3|max:254"
                  v-slot="{ errors }"
                >
                  <b-form-input
                    id="email"
                    type="email"
                    placeholder="Email address..."
                    v-model="form.email"
                  />
                  <div
                    class="field-check"
                    v-if="form.email && errors.length < 1"
                  ></div>

                  <b-form-row class="text-danger">
                    <template v-if="errors.length > 0">
                      <i class="fa fa-warning"></i>
                      <span class="help invalid-feedback">
                        {{ errors[0] }}
                      </span>
                    </template>
                  </b-form-row>
                </ValidationProvider>
              </div>
            </div>

            <div id="passwordGroup" horizontal class="form-group">
              <div class="form-field">
                <ValidationProvider
                  name="Password"
                  rules="required|min:8|max:36"
                  v-slot="{ errors }"
                >
                  <b-form-input
                    id="password"
                    type="password"
                    placeholder="Password..."
                    v-model="form.password"
                  />
                  <div
                    class="field-check"
                    v-if="form.password && errors.length < 1"
                  ></div>
                  <b-form-row class="text-danger">
                    <template v-if="errors.length > 0">
                      <i class="fa fa-warning"></i>
                      <span class="help invalid-feedback">
                        {{ errors[0] }}
                      </span>
                    </template>
                  </b-form-row>
                </ValidationProvider>
              </div>
              <router-link
                :to="{ path: 'forgot-password' }"
                class="forgot-password"
                >Forgot Password?</router-link
              >
            </div>
            <div class="invalid-feedback" v-for="error in errors" :key="error">
              {{ error }}
            </div>
            <div class="form-btn">
              <b-button :disabled="invalid" type="submit" variant="primary"
                >Sign in
              </b-button>
            </div>
            <p class="signing-text">
              Don’t have an account?
              <router-link
                :to="{ path: 'register', query: { uuid: $route.query.uuid } }"
                >Sign Up</router-link
              >
            </p>
          </b-form>
        </ValidationObserver>
      </div>
      <div class="thanks-signing d-none">
        <p>
          Thanks for signing up to the Analyst Hub! You’ll receive a
          confirmation email soon.
        </p>
        <div class="thanks-check">
          <img src="/assets/img/check-icon-big.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="login-right-part">
      <div class="login-right-logo">
        <img src="/assets/img/right-logo.svg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ApiService from "../api/api.service";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      errors: [],
    };
  },
  computed: {
    ...mapGetters(["loginErrors"]),
  },
  methods: {
    signIn() {
      this.$store
        .dispatch("login", {
          email: this.form.email,
          password: this.form.password,
        })
        .then((res) => {
          // Check if the user has team invitation
          if (res.token) {
            this.teamInvitaionCheck();
          }
        })
        .catch(({ data }) => {
          this.errors = [data.error];
        });
    },

    teamInvitaionCheck() {
      ApiService.setHeader();
      ApiService.post("/api/teams/invites")
        .then(({ data }) => {
          if (data.invitation && data.invitation.team) {
            this.$router.push({
              name: "Team Member Join",
              params: { uuid: data.invitation.team.uuid },
            });
            return;
          } else {
            // go back to previous page
            this.$router.go(-1);
          }
        })
        .catch();
    },
  },
};
</script>
<style>
</style>
